module.exports = __webpack_public_path__ + "static/media/DSC_0109-2.5b34f242.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/DSC_0109-2.jpg
// module id = 592
// module chunks = 0